import { Filters } from 'client/components/Gallery/Filters'
import { usePersonalizationConfig, PersonalizationCard } from 'client/components/Gallery/DesignPersonalization'

export const FiltersSidebar = () => {
  const { isEnabled, mode, imageCopyKey } = usePersonalizationConfig()
  const showPersonalization = isEnabled && mode === 'sidebar'

  return (
    <nav className="left-nav">
      {showPersonalization && <PersonalizationCard />}
      <Filters showAlternativeHeader={showPersonalization} showColorFirst={showPersonalization && imageCopyKey !== 'Photo'} />
    </nav>
  )
}

FiltersSidebar.displayName = 'FiltersSidebar'
